import ReactGA from "react-ga4";
import logo from "./logo.svg";
import "./App.css";
import NavBar from "./components/NavBar";
import styled from "styled-components";
import colors from "./constatns/colors";
import Home from "./screens/Home";
import About from "./screens/About";
import useWindowDimensions from "./constatns/size";
import Ecosystem from "./screens/Ecosystem";
import RoadMap from "./screens/RoadMap";
import Tokenomics from "./screens/Tokenomics";
import Team from "./screens/Team";
import Reference from "./screens/Reference";
import FAQS from "./screens/FAQS";
import ContactUs from "./screens/ContactUs";
import Footer from "./screens/Footer";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material";
import Gega from "./screens/Gega";
import { useEffect } from "react";

const MEASURMENT_ID = "G-QK3WV2RMH9";
//ReactGA.initialize(MEASURMENT_ID);

function App() {
  const theme = createTheme({
    palette: {
      type: "light",
      primary: {
        light: colors.primary,
        main: colors.btnPrimary,
      },
    },
  });

  ReactGA.initialize(MEASURMENT_ID);
  const page = window.location.pathname + window.location.search;
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: page });
    ReactGA.set({ page: page });
  });

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <NavBar />
        <Home />
        <About />
        <Ecosystem />
        <RoadMap />
        <Tokenomics />
        <Gega />
        <Team />
        <Reference />
        <FAQS />
        <ContactUs />
        <Footer />
      </Container>
    </ThemeProvider>
  );
}

const Container = styled.div`
  background-color: ${colors.primary};
  display: flex;
  flex-direction: column;
`;

export default App;
